import { useEffect } from 'react';
import { Alert } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import {
  cleanFile,
  cleanMsg,
  getPuestosPublicos,
  useDenominaciones,
} from '../../../../../../appStore/denominaciones';
import { useConcurso } from '../../../../../../providers/ConcursoProvider';
import AlertDialog from '../../../../../CompUtils/AlertDialog';
import { CommonRoot } from '../../../../../CompUtils/CommonRoot';
import { CommonTitle } from '../../../../../CompUtils/CommonTitle';
import { FileModal } from '../../../../../CompUtils/FileModal';
import FullLoading from '../../../../../CompUtils/FullLoading';
import { MainTable } from './MainTable';
import { PuestoTableProps, PuestosTableProvider } from './PuestosTableProvider';

export const PuestosTable = (props: PuestoTableProps) => {
  const { idLlamadoConcurso } = useConcurso();
  const dispatch = useDispatch();
  const { error, dataPublico, file, loading } = useDenominaciones();
  useEffect(() => {
    dispatch(getPuestosPublicos({ idLlamadoConcurso }));
  }, [dispatch, idLlamadoConcurso]);
  return (
    <PuestosTableProvider {...props}>
      <CommonRoot>
        <CommonTitle
          title="Denominaciones Cargadas"
          subtitle="Listado de puestos disponibles para aplicar a la convocatoria"
        />
        {error !== '' && (
          <p className="text-danger">
            <small>{error}</small>
          </p>
        )}
        {dataPublico?.length === 0 && error === '' && (
          <Alert variant="primary"> No hay Denominaciones cargadas para este concurso !</Alert>
        )}
        {dataPublico?.length !== 0 && <MainTable />}
      </CommonRoot>
      <FullLoading show={loading} />
      <AlertDialog
        show={!!error}
        title="Concursar"
        subtitle={error}
        onClose={() => {
          dispatch(cleanMsg());
        }}
      />
      <FileModal file={file} onClose={() => dispatch(cleanFile())} title="Bases y condiciones" />
    </PuestosTableProvider>
  );
};
